import { createAsyncAction } from 'typesafe-actions';
import { EntityTrade } from '../../../models/EntityTrade';

import {
  AddEntityTradesToDealRequestPayload,
  CreateTradeWithPricerRequestPayload,
  CreateUpdateDealRequestPayload,
  DealSummaryReportRequestPayload,
  DownloadDealTermSheetPayload,
  GetAllHedgingInstrumentsSuccessPayload,
  GetDealTradesByGVRequestPayload,
  GetDealTradesByGVSuccessPayload,
  GetGoldVisionDealRequestPayload,
  GetGoldVisionDealSuccessPayload,
  PatchPayload,
} from './types';
import { DealDocument } from '../types';

export const getGoldVisionDeal = createAsyncAction(
  'deals/getGoldVisionDeal/request',
  'deals/getGoldVisionDeal/success',
  'deals/getGoldVisionDeal/failure',
)<
  GetGoldVisionDealRequestPayload,
  GetGoldVisionDealSuccessPayload,
  undefined
>();

export const getDealTradesByGVId = createAsyncAction(
  'deals/getDealTradesByGVId/request',
  'deals/getDealTradesByGVId/success',
  'deals/getDealTradesByGVId/failure',
)<
  GetDealTradesByGVRequestPayload,
  GetDealTradesByGVSuccessPayload,
  undefined
>();

export type GetDealDocumentsRequestPayload = {
  deal_id: number;
};
export type GetDealDocumentsSuccessPayload = {
  data: DealDocument[];
};
export const getDealDocuments = createAsyncAction(
  'deals/getDealDocuments/request',
  'deals/getDealDocuments/success',
  'deals/getDealDocuments/failure',
)<GetDealDocumentsRequestPayload, GetDealDocumentsSuccessPayload, undefined>();

export type UploadDealDocumentRequestPayload = {
  file_key: string;
  file_name: string;
  document_type_id: string;
  deal_center_deals_id: number;
};

export const uploadDealDocument = createAsyncAction(
  'deals/uploadDealDocument/request',
  'deals/uploadDealDocument/success',
  'deals/uploadDealDocument/failure',
)<UploadDealDocumentRequestPayload, undefined, undefined>();

export type GetEntityTradesRequestPayload = {
  comp_ent_id: string;
  run_date: string;
};
export type GetEntityTradesSuccessPayload = {
  data: EntityTrade[];
};
export const getEntityTrades = createAsyncAction(
  'deals/getEntityTrades/request',
  'deals/getEntityTrades/success',
  'deals/getEntityTrades/failure',
)<GetEntityTradesRequestPayload, GetEntityTradesSuccessPayload, undefined>();

export const addEntityTradesToDeal = createAsyncAction(
  'deals/addEntityTradesToDeal/request',
  'deals/addEntityTradesToDeal/success',
  'deals/addEntityTradesToDeal/failure',
)<AddEntityTradesToDealRequestPayload, undefined, undefined>();

export const getAllHedgingInstruments = createAsyncAction(
  'deals/getAllHedgingInstruments/request',
  'deals/getAllHedgingInstruments/success',
  'deals/getAllHedgingInstruments/failure',
)<undefined, GetAllHedgingInstrumentsSuccessPayload, undefined>();

export const createTradeWithPricer = createAsyncAction(
  'deals/createTradeWithPricer/request',
  'deals/createTradeWithPricer/success',
  'deals/createTradeWithPricer/failure',
)<CreateTradeWithPricerRequestPayload, undefined, undefined>();
/////

export const createOrEditDealDetails = createAsyncAction(
  'deals/createOrEditDealDetails/request',
  'deals/createOrEditDealDetails/success',
  'deals/createOrEditDealDetails/failure',
)<CreateUpdateDealRequestPayload, undefined, undefined>();

export const downloadDealSummaryReport = createAsyncAction(
  'deals/downloadDealSummaryReport/request',
  'deals/downloadDealSummaryReport/success',
  'deals/downloadDealSummaryReport/failure',
)<DealSummaryReportRequestPayload, undefined, undefined>();

export const updatePartialDealDetails = createAsyncAction(
  'deals/updatePartialDealDetails/request',
  'deals/updatePartialDealDetails/success',
  'deals/updatePartialDealDetails/failure',
)<PatchPayload, undefined, undefined>();

export const downloadDealTermSheet = createAsyncAction(
  'deals/downloadDealTermSheet/request',
  'deals/downloadDealTermSheet/success',
  'deals/downloadDealTermSheet/failure',
)<DownloadDealTermSheetPayload, undefined, undefined>();
